import { Component, HostBinding, Input, Output, EventEmitter, OnInit, ViewEncapsulation } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Ng2SmartTableModule, LocalDataSource, ViewCell } from 'ng2-smart-table';

@Component({
    selector: 'link-view',
    template: `
    <a style="color:#1e6bb8;" (click)="onClick()">{{value}}</a>
  `,
})
export class LinkViewComponent implements ViewCell, OnInit {
    renderValue: string;

    @Input() value: string | number;
    @Input() rowData: any;

    @Output() save: EventEmitter<any> = new EventEmitter();

    ngOnInit() {
        this.renderValue = this.value.toString().toUpperCase();
    }

    onClick() {
        this.save.emit(this.rowData);
    }
}
